(function() {
    'use strict';

    angular
        .module('backApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
